"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardMessageOption_1 = require("./actions/discardMessageOption");
var saveMessageOption_1 = require("./actions/saveMessageOption");
var MessageOptionsFull_1 = require("./components/MessageOptionsFull");
var isMessageOptionDirty_1 = require("./utils/isMessageOptionDirty");
var React = require("react");
var MessageOption = {
    key: 'message',
    titleStringKey: 'optionTitle_message',
    searchTermsStringKey: 'optionTitle_message',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MessageOptionsFull_1.default, null); },
        isDirty: isMessageOptionDirty_1.default,
        onSave: saveMessageOption_1.default,
        onDiscard: discardMessageOption_1.default,
    },
};
exports.default = MessageOption;
//# sourceMappingURL=MessageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/MessageOption.js
// module id = 5052
// module chunks = 2